import { ConversationSummary, LinkedFrom } from '../core/hub-types';

/**
 * Where a linked copy came from, for "Linked from ... by ...". The hub calls every conversation that is not a group,
 * a patient chat, a referral or support "a direct message", billing chats included, so that label is checked against
 * the source when this session has it, and said neutrally when it does not.
 */
export function linkedFromLabel(from: Pick<LinkedFrom, 'label'>, source: ConversationSummary | undefined): string {
  if (source?.type === 'billing') return source.billing?.counterpartName ? `the chat with ${source.billing.counterpartName}` : 'a billing chat';
  if (from.label === 'a direct message' && source?.type !== 'direct' && source?.type !== 'group_dm') return 'a chat';
  return from.label;
}
